

export const TENANT = {
    DATA_SUBMISSION_CLIENT_ID: process.env.REACT_APP_DATA_SUBMISSION_CLIENT_ID,
}




// WEBPACK FOOTER //
// ./src/sub-projects/tenant/constants/index.tsx